import React, { FC, useEffect, useState } from 'react'
import classNames from 'classnames'
import { t } from '@lingui/macro'

import { useSelector } from 'react-redux'
import {
  channelSelector,
  isSwedishHandballSelector
} from 'redux-store/channel/channel.selectors'
import MEDIA_OBJECT from 'constants/media_object.constants'
import { useLocation } from 'react-router-dom'
import { ReplaceLink } from 'components/ReplaceLink/ReplaceLink'
import { useSearchParam } from 'hooks/useSearchParam'
import menuItems, {
  ViewerPageMenuOption
} from 'features/viewerPage/components/StreamSubmenu/StreamSubmenuLinks'

import styles from './StreamSubmenu.module.scss'
import { GameWithoutLivestream } from '../../types'

const getSelectedTab = (menuItems: any, selectedTab: string) => {
  return menuItems.find((link: any) => `?tab=${selectedTab}` === link.link)
}

export const getBroadcastPath = (
  pathname: string,
  subdomain: string,
  mediaObject: any
) => {
  const id = mediaObject.id
  return `/${subdomain}/games/g/${id}`
}

type StreamSubmenuProps = {
  mediaObject: GameWithoutLivestream
}

export const StreamSubmenu: FC<StreamSubmenuProps> = ({ mediaObject }) => {
  const isSwedishHandball = useSelector(isSwedishHandballSelector)
  const channel = useSelector(channelSelector)
  const location = useLocation()
  const tab = useSearchParam('tab')
  const fallbackMenuId = ViewerPageMenuOption.AboutStream
  const showGameLineups = isSwedishHandball
  // for future we must use hasGame or canComment to show other tabs
  //   const { hasGame, canComment } = mediaObject
  const hasGame = false
  const canComment = false

  const { pathname } = location

  const selectedLink = getSelectedTab(menuItems, tab ? tab : 'about')
  const initialSelectedMenu = selectedLink ? selectedLink.id : fallbackMenuId
  const [selectedMenuId, setSelectedMenuId] = useState(initialSelectedMenu)
  const showChat =
    mediaObject?.type === MEDIA_OBJECT.TYPES.LIVESTREAM ||
    mediaObject?.is_replay

  const broadcastPath =
    mediaObject &&
    getBroadcastPath(pathname, channel?.data?.subdomain, mediaObject)

  useEffect(() => {
    const items = menuItems.filter((link) =>
      link.id === ViewerPageMenuOption.Chat ? canComment : true
    )
    if (items.length === 1) {
      setSelectedMenuId(items[0].id)
    } else {
      setSelectedMenuId(initialSelectedMenu)
    }
  }, [canComment, selectedLink, initialSelectedMenu])

  const items = menuItems.filter((link) => {
    switch (link.id) {
      case ViewerPageMenuOption.Chat:
        return canComment
      case ViewerPageMenuOption.Result:
        return hasGame
      case ViewerPageMenuOption.Lineup:
        return hasGame && showGameLineups
      default:
        return true
    }
  })
  return (
    <div
      className={classNames(styles.ViewerSubmenuContainer)}
      data-testid="viewer-page-submenu-container"
    >
      <ul data-testid="viewer-page-submenu-list">
        {items.map((link) => {
          const isSelected = link.id === selectedMenuId || items.length === 1
          return (
            <li
              data-testid={`viewer-page-submenu-${link.id}`}
              key={link.id}
              className={classNames({
                [styles.NotSelected]: !isSelected
              })}
              onClick={() => setSelectedMenuId(link.id)}
              onKeyUp={(event) => {
                if (event.key === ' ') {
                  setSelectedMenuId(link.id)
                }
              }}
            >
              {!showChat && link.id === ViewerPageMenuOption.Chat ? (
                <ReplaceLink
                  link={`${broadcastPath}?tab=comments`}
                  translationText={t`Comments`}
                />
              ) : (
                // I kept it for testing purposes when we had chat feature for games, but it should be removed
                // <ReplaceLink
                //   {...{ ...link, link: `${broadcastPath}${link.link}` }}
                // />
                <ReplaceLink
                  link={`${broadcastPath}${link.link}`}
                  translationText={link.translationText}
                />
              )}
              <br />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
